export default "__VITE_ASSET__DUKhQOEk__"